/*
 * Product events for Google Analytics, sent through the Tag Manager container (see
 * utils/googleTagManager.js — GTM turns each gtag('event') on the dataLayer into a GA4 event).
 *
 * Europe only, and only once the visitor has allowed analytics. The check lives here so a call site
 * never has to repeat it: the Russian build measures through Yandex.Metrika and has no container,
 * and in Europe nothing non-essential may be reported before the banner is answered.
 */

import { IS_EUROPE } from '../config/region';
import { allows } from './consent';
import { gtag } from './googleConsent';

/* Returns whether the event was sent, so a one-shot caller only burns its flag on a real send. */
export const trackEvent = (name, params) => {
  if (!IS_EUROPE || !allows('analytics')) return false;
  gtag('event', name, params);
  return true;
};

/* "10 messages in one session": fires on every 10th message (10, 20, 30, ...), so it can fire
   several times in one session. The count lives in sessionStorage, so it covers one tab's visit and
   survives reloads but not a new tab. Counted even before consent, so a visitor who accepts the
   banner mid-session is not restarted from zero. */
const SESSION_MESSAGES_KEY = 'pp-session-messages';
const SESSION_MESSAGES_STEP = 10;

export const trackSessionMessage = () => {
  const count = parseInt(sessionStorage.getItem(SESSION_MESSAGES_KEY) || '0', 10) + 1;
  sessionStorage.setItem(SESSION_MESSAGES_KEY, String(count));
  if (count % SESSION_MESSAGES_STEP === 0) trackEvent(`messages_${SESSION_MESSAGES_STEP}`);
};
